import { render } from "./KontakPage.vue?vue&type=template&id=0d492abe"
import script from "./KontakPage.vue?vue&type=script&lang=js"
export * from "./KontakPage.vue?vue&type=script&lang=js"

import "./KontakPage.vue?vue&type=style&index=0&id=0d492abe&lang=css"

import exportComponent from "/builds/christinandrea/kel1-kedaireka/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__